import { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./styles/RoundIcon.module.scss";
import { sourceTypesEnum } from "../../../utils/SourceUtils";

export default class RoundIcon extends Component {
  static propTypes = {
    className: PropTypes.string,
    platform: PropTypes.string,
  };

  render() {
    const roundIconClassName = classNames({
      [styles.roundIcon]: true,
      [this.props.className]: this.props.className,
      [styles.roundIconFacebook]:
        this.props.platform === sourceTypesEnum.FACEBOOK,
      [styles.roundIconTwitter]:
        this.props.platform === sourceTypesEnum.TWITTER,
      [styles.roundIconInstagram]:
        this.props.platform === sourceTypesEnum.INSTAGRAM,
      [styles.roundIconVimeo]: this.props.platform === sourceTypesEnum.VIMEO,
      [styles.roundIconYoutube]:
        this.props.platform === sourceTypesEnum.YOUTUBE,
      [styles.roundIconPinterest]:
        this.props.platform === sourceTypesEnum.PINTEREST,
      [styles.roundIconGoogle]:
        this.props.platform === sourceTypesEnum.GOOGLE_PLACES ||
        this.props.platform === sourceTypesEnum.GOOGLE_DRIVE,
      [styles.roundIconCalendar]: this.props.platform === sourceTypesEnum.ICAL,
      [styles.roundIconYelp]: this.props.platform === sourceTypesEnum.YELP,
      [styles.roundIconRss]: this.props.platform === sourceTypesEnum.RSS,
      [styles.roundIconError]: this.props.platform === sourceTypesEnum.ERROR,
      [styles.roundIconO365]: this.props.platform === sourceTypesEnum.O365,
      [styles.roundIconClassroom]:
        this.props.platform === sourceTypesEnum.GOOGLE_CLASSROOM, //TODO need to get classroom flaticon
      [styles.roundIconNewsFeed]:
        this.props.platform === sourceTypesEnum.SERP_API,
    });

    return <div className={roundIconClassName}>{this.props.children}</div>;
  }
}
